import { useCallback } from 'react';
import { bridge } from 'shared/src/utils';
import type { OverviewCategory, OverviewSubCategory } from 'shared/src/api';

export const useLogClickIconList = () => {
  return useCallback(
    (subCategory: OverviewSubCategory, category: OverviewCategory) => {
      bridge.logAnalyticsEvent({
        name: 'CLICK_ICON_LIST',
        analytics: {
          ...subCategory.logging.analytics,
          CATEGORY_NAME: category.item.name,
          CATEGORY_SNO: category.item.sno,
          SCREEN: 'OVERVIEW',
        },
      });
    },
    [],
  );
};
